import { bossWebAxios } from '../api';
import { moduleNameMap } from '../config';

const {
  TW_MERCHANT_BOSS,
  DISCOVERY_BOSS
} = moduleNameMap;
const orderBoss = `${TW_MERCHANT_BOSS}/boss`;

// 订单列表查询
export const getOrderList = (params, config) => bossWebAxios(params, `${orderBoss}/list-merchant-order`, config)

// 接单
export const receiveOrder = (params, config) => bossWebAxios(params, `${orderBoss}/accept-order`, config)
// 拒单
export const refuseOrder = (params, config) => bossWebAxios(params, `${orderBoss}/reject-order`, config)
// 获取拒单原因列表
export const refuseOrderReasonList = (params, config) => bossWebAxios(params, `${orderBoss}/order/cancel-reason/configuration/list`, config)
// 批量接单
export const batchOrder = (params, config) => bossWebAxios(params, `${orderBoss}/batch-accept-order`, config)
// 修改备餐状态
export const updateMealStatus = (params, config) => bossWebAxios(params, `${orderBoss}/change-prepare-meal-state-order`, config)
// 商家同意取消订单
export const agreeCancel = (params, config) => bossWebAxios(params, `${orderBoss}/agree-cancel-order`, config)
// 商家拒绝取消订单
export const rejectCancel = (params, config) => bossWebAxios(params, `${orderBoss}/order/cancel/reject`, config)
// 商家同意退款
export const agreeRefund = (params, config) => bossWebAxios(params, `${orderBoss}/agree-refund-order`, config)
// 商家拒绝退款
export const rejectRefund = (params, config) => bossWebAxios(params, `${orderBoss}/reject-refund-order`, config)
// 统计状态栏数据
export const orderCount = (params, config) => bossWebAxios(params, `${orderBoss}/count-status`, config)

// 订单评价列表
export const evaluationList = (params, config) => bossWebAxios(params, `${DISCOVERY_BOSS}/review/queryItemCriticalReview.do`, config)
// 商户回复评价
export const evaluationReply = (params, config) => bossWebAxios(params, `${DISCOVERY_BOSS}/review/replyReview.do`, config)
// 查询门店评分
export const evaluationShowScore = (params, config) => bossWebAxios(params, `${DISCOVERY_BOSS}/review/queryAvgScoreByMerchant.do`, config)

// 查询自动接单的状态
export const searchAutoReviewOrder = (params, config) => bossWebAxios(params, `${orderBoss}/auto-accept-order-state/query`, config)
// 修改自动接单的状态
export const editAutoReviewOrder = (params, config) => bossWebAxios(params, `${orderBoss}/auto-accept-order-state/update`, config)

// 创建订单反馈
export const createFeedback = (params, config) => bossWebAxios(params, `${orderBoss}/post-sale/create`, config)
// 查询订单反馈原因列表
export const queryFeedbackReason = (params, config) => bossWebAxios(params, `${orderBoss}/feedbackReason/list`, config)
// 查询订单反馈详情
export const queryFeedbackDetail = (params, config) => bossWebAxios(params, `${orderBoss}/post-sale/detail`, config)
// 查询订单反馈日志
export const queryFeedbackLog = (params, config) => bossWebAxios(params, `${orderBoss}/post-sale/log/list`, config)

// 用户已取餐
export const userPickedOrder = (params, config) => bossWebAxios(params, `${orderBoss}/order/finish`, config)

export const exportOrderList = (params, config) => bossWebAxios(params, `${orderBoss}/export-merchant-order`, config)
